import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-metiers-form',
  templateUrl: './metiers-form.component.html',
  styleUrls: ['./metiers-form.component.scss']
})
export class MetiersFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
